'use client';

import {useQuery} from '@/sanity/loader/useQuery';

import Page from './Page';
import type {PageBySlugQueryResult} from './query';
import {PAGE_BY_SLUG_QUERY} from './query';

type Props = {
	params: {slug: string};
	initial: PageBySlugQueryResult;
};

export default function PageDraft({initial, params}: Props) {
	const {data: page} = useQuery<PageBySlugQueryResult>(initial, PAGE_BY_SLUG_QUERY, params);

	return <Page page={page} />;
}
